<div fxLayout="column">
  <i *ngIf="saving" class="fas fa-spinner fa-spin"></i>

  <mat-divider></mat-divider>
  <form [formGroup]="billingSetupForm">
    <mat-form-field appearance="fill" style="margin: 20px;">
      <mat-label>Address Line 1</mat-label>
      <input formControlName="addressLine1" matInput #input maxlength="50" placeholder="addressLine1">
      <mat-error *ngIf="billingSetupForm.controls.addressLine1?.errors?.required">
        Field <strong>required</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="fill" style="margin: 20px;">
      <mat-label>City</mat-label>
      <input formControlName="city" matInput #input maxlength="50" placeholder="city">
      <mat-error *ngIf="billingSetupForm.controls.city?.errors?.required">
        Field <strong>required</strong>
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill" style="margin: 20px;">
      <mat-label>Country</mat-label>
      <input formControlName="country" matInput #input maxlength="50" placeholder="country">
      <mat-error *ngIf="billingSetupForm.controls.country?.errors?.required">
        Field <strong>required</strong>
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill" style="margin: 20px;">
      <mat-label>Zip Code</mat-label>
      <input formControlName="zipCode" matInput #input maxlength="50" placeholder="Zip Code">
      <mat-error *ngIf="billingSetupForm.controls.zipCode?.errors?.required">
        Field <strong>required</strong>
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill" style="margin: 20px;">
      <mat-label>SDI Code </mat-label>
      <input formControlName="codeSDI" matInput #input maxlength="50" placeholder="SDI code">
      <mat-error *ngIf="billingSetupForm.controls.codeSDI?.errors?.required">
        Field <strong>required</strong>
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill" style="margin: 20px;">
      <mat-label>VAT number </mat-label>
      <input formControlName="codeSDI" matInput #input maxlength="50" placeholder="VAT number">
      <mat-error *ngIf="billingSetupForm.controls.vatNumber?.errors?.required">
        Field <strong>required</strong>
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill" style="margin: 20px;">
      <mat-label>Description</mat-label>
      <input formControlName="description" matInput #input maxlength="50" placeholder="Description">
      <mat-error *ngIf="billingSetupForm.controls.description?.errors?.required">
        Field <strong>required</strong>
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill" style="margin: 20px;">
      <mat-label>Email</mat-label>
      <input formControlName="email" type="email" matInput placeholder="Ex. pat@example.com">
      <mat-error
        *ngIf="billingSetupForm.controls.email?.errors?.email && !billingSetupForm.controls.email?.errors?.required">
        Please enter a valid email address
      </mat-error>
      <mat-error *ngIf="billingSetupForm.controls.email?.errors?.required">
        Field <strong>required</strong>
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill" style="margin: 20px;">
      <mat-label>Identifier</mat-label>
      <input formControlName="identifier" matInput #input maxlength="50" placeholder="Identifier">
      <mat-error *ngIf="billingSetupForm.controls.identifier?.errors?.required">
        Field <strong>required</strong>
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill" style="margin: 20px;">
      <mat-label>PEC</mat-label>
      <input formControlName="pec" matInput #input maxlength="50" placeholder="PEC">
      <mat-error
        *ngIf="billingSetupForm.controls.pec?.errors?.email && !billingSetupForm.controls.pec?.errors?.required">
        Please enter a valid email address
      </mat-error>
      <mat-error *ngIf="billingSetupForm.controls.pec?.errors?.required">
        Field <strong>required</strong>
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill" style="margin: 20px;">
      <mat-label>Phone</mat-label>

      <input formControlName="phone" matInput #input maxlength="50" placeholder="Ex. Nougat" autofocus>

      <mat-error *ngIf="billingSetupForm.controls.phone?.errors?.required">
        Field <strong>required</strong>
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill" style="margin: 20px;">
      <mat-label>Month</mat-label>
      <input formControlName="month" matInput #input maxlength="50" placeholder="Month">
      <mat-error *ngIf="billingSetupForm.controls.month?.errors?.required">
        Field <strong>required</strong>
      </mat-error>
    </mat-form-field>
    <mat-form-field appearance="fill" style="margin: 20px;">
      <mat-label>Type</mat-label>
      <input formControlName="type" matInput #input maxlength="50" placeholder="Type">

      <mat-error *ngIf="billingSetupForm.controls.type?.errors?.required">
        Field <strong>required</strong>
      </mat-error>
    </mat-form-field>

    <mat-form-field *ngIf="partner == true" appearance="fill"
      style="margin-top: 30px; margin-left: 30px; align-content: center;">
      <mat-select [(value)]="selectMonth" formControlName="month" name="month">
        <mat-option *ngFor="let month of months" value="{{month}}">
          {{month}} Month
        </mat-option>
      </mat-select>
      <mat-error *ngIf="billingSetupForm.controls.month?.errors?.required">
        Field <strong>required</strong>
      </mat-error>
    </mat-form-field>
    <mat-radio-group *ngIf="partner == true" formControlName="type" [value]="">
      <mat-radio-button [checked]="radioTypeAnticipated" value="1">Anticipated</mat-radio-button>
      <mat-radio-button [checked]="radioTypePostponed" value="2">Postponed</mat-radio-button>
    </mat-radio-group>

  </form>
  <mat-divider></mat-divider>

  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

      <!-- ID Column -->
      <!-- <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef > Id </th>
            <td mat-cell *matCellDef="let element"> {{element.id}} </td>
        </ng-container> -->

      <!-- Column Percentage -->
      <ng-container matColumnDef="percentage">
        <th mat-header-cell *matHeaderCellDef> Percentage </th>
        <td mat-cell *matCellDef="let element">
          <mat-form-field >
            <input matInput placeholder="Name" type="number" min="0" [value]="element.percentage"
              [(ngModel)]="element.percentage" [disabled]="!(loggedUser.role === roles.admin)">
          </mat-form-field>
        </td>
      </ng-container>

      <!-- Column description -->
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Description </th>
        <td mat-cell *matCellDef="let element">
          <mat-form-field >
            <input *ngIf="element.billingItemType.id == 3" matInput placeholder="Description"
              [value]="element.description" [(ngModel)]="element.description"
              [disabled]="!(loggedUser.role === roles.admin)">
            <input *ngIf="element.billingItemType.id == 2" matInput placeholder="Description" value="Researcher"
              [disabled]="!(loggedUser.role === roles.admin)">
            <input *ngIf="element.billingItemType.id == 1" matInput placeholder="Description" value="Box"
              [disabled]="!(loggedUser.role === roles.admin)">
          </mat-form-field>
        </td>
      </ng-container>

      <!-- units Column -->
      <ng-container matColumnDef="units">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> units</th>
        <td mat-cell *matCellDef="let element">
          <mat-form-field >
            <input type="number" min="0" matInput placeholder="units" [value]="element.units"
              [(ngModel)]="element.units" [disabled]="!(loggedUser.role === roles.admin)">

          </mat-form-field>
        </td>
      </ng-container>

      <!-- unitCost Column -->
      <ng-container matColumnDef="unitCost">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Unit Cost </th>
        <td mat-cell *matCellDef="let element">
          <mat-form-field >
            <input matInput type="number" min="0" placeholder="unitCost" [value]="element.unitCost"
              [(ngModel)]="element.unitCost" [disabled]="!(loggedUser.role === roles.admin)">
          </mat-form-field>
        </td>
      </ng-container>

      <!-- unitCost Column -->
      <ng-container matColumnDef="invoicePeriod">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Invoice Period</th>
        <td mat-cell *matCellDef="let element">
          <mat-form-field >
            <input matInput placeholder="Invoice Period" [value]="element.invoicePeriod"
              [(ngModel)]="element.invoicePeriod" [disabled]="!(loggedUser.role === roles.admin)">
          </mat-form-field>
        </td>
      </ng-container>

      <!-- Change Column -->
      <ng-container matColumnDef="Change">
        <th mat-header-cell *matHeaderCellDef> </th>
        <td mat-cell *matCellDef="let element">
          <button [disabled]="!(loggedUser.role === roles.admin)" mat-raised-button (click)="updateBillingItem(element)"
            matTooltip="Edit Billing Item">
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <!-- Delete Column -->
      <ng-container matColumnDef="Delete">
        <th mat-header-cell *matHeaderCellDef> </th>
        <td mat-cell *matCellDef="let element">
          <button [disabled]="!(loggedUser.role === roles.admin)" mat-raised-button (click)="deleteItems(element)"
            matTooltip="Delete Billing Item">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnsItems"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsItems;"></tr>
    </table>
  </div>
  <re-captcha *ngIf="isRegistrationRequest" fxFlex="45" formControlName="recaptchaReactive" name="recaptchaReactive"
    size="normal" [siteKey]="recaptchaKey"></re-captcha>


  <div fxFlex="100" fxLayout="row" fxLayoutAlign="end">
    <mat-divider></mat-divider>
    <ng-container *ngIf="!isRegistrationRequest">
      <button (click)="billingSetup = _items; canceled.emit()" mat-button>Cancel</button>
      <button *ngIf="(loggedUser.role === roles.admin)" color="primary" (click)="saveEditSetup()" mat-button>
        <i *ngIf="saving" class="fas fa-spinner fa-spin"></i>
        <ng-container *ngIf="!saving">Save</ng-container>
      </button>
    </ng-container>
  </div>
</div>